import { useLocation } from "react-router";

interface BreadcrumbItem {
  label: string;
  to: string;
  isLast: boolean;
}

interface ProjectNav {
  activeSegment: string;
  breadcrumbTrail: BreadcrumbItem[];
}

interface ProjectNavOptions {
  ticketKey?: string;
  ticketId?: string;
}

export function useProjectNav(id: string, options: ProjectNavOptions = {}): ProjectNav {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);
  const idIndex = segments.indexOf(id);
  const rest = segments.slice(idIndex + 1);

  const activeSegment = rest[0] ?? "";

  const breadcrumbTrail = rest.map((seg, i) => {
    let label: string;
    if (seg === "new") {
      label = "New ticket";
    } else if (options.ticketKey && options.ticketId && seg === options.ticketId) {
      label = options.ticketKey;
    } else if (seg === "edit") {
      label = "Edit";
    } else {
      label = seg.charAt(0).toUpperCase() + seg.slice(1);
    }

    return {
      label,
      to: `/projects/${id}/${rest.slice(0, i + 1).join("/")}`,
      isLast: i === rest.length - 1,
    };
  });

  return { activeSegment, breadcrumbTrail };
}
